module.exports = __webpack_public_path__ + "img/carro2.726d591f.jpg";